/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiation-constraint.reducer';

export const RadiationConstraintDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiationConstraintEntity = useAppSelector(state => state.radiationConstraint.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiationConstraintDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiationConstraint.detail.title">RadiationConstraint</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiationConstraint.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiationConstraintEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.radiationConstraint.name">Name</Translate>
            </span>
          </dt>
          <dd>{radiationConstraintEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.radiationConstraint.description">Description</Translate>
            </span>
          </dt>
          <dd>{radiationConstraintEntity.description}</dd>
          <dt>
            <span id="constraintType">
              <Translate contentKey="tinyMedicRestApp.radiationConstraint.constraintType">Constraint Type</Translate>
            </span>
          </dt>
          <dd>{radiationConstraintEntity.constraintType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiationConstraint.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiationConstraintEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiationConstraint.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiationConstraintEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.radiationConstraint.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{radiationConstraintEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiationConstraint.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiationConstraintEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.radiationConstraint.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{radiationConstraintEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationConstraint.radiationSession">Radiation Session</Translate>
          </dt>
          <dd>
            {radiationConstraintEntity.radiationSessions
              ? radiationConstraintEntity.radiationSessions.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {radiationConstraintEntity.radiationSessions && i === radiationConstraintEntity.radiationSessions.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/radiation-constraint" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiation-constraint/${radiationConstraintEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiationConstraintDetail;
